import React from 'react';
// Importamos las herramientas de navegación
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// Importamos Helmet para el SEO
import { Helmet, HelmetProvider } from 'react-helmet-async';

// Tus componentes actuales
import Navbar from './components/Navbar';
import Hero from './components/Hero'; 
import Planes from './components/Planes';
import Formulario from './components/Formulario';
import Chatbot from './components/Chatbot';
import Footer from './components/Footer'; 

// Tu nueva página
import PlanesDetalle from './pages/PlanesDetalle';

function App() {
  return (
    <HelmetProvider>
      <Router>
        {/* Configuración SEO Global */}
        <Helmet>
          <title>PABS Torreón | Planes de Previsión Funeraria</title>
          <meta name="description" content="Protege a tu familia con PABS en Torreón. Planes de previsión con cobertura nacional y en USA. Atención de Gustavo Márquez Ríos." />
          <meta name="keywords" content="PABS Torreón, funeraria Torreón, previsión funeraria, planes funerarios Coahuila, PABS" />
          <link rel="canonical" href="https://tu-sitio-pabs.netlify.app/" />
        </Helmet>

        <div className="bg-black text-white selection:bg-yellow-500 flex flex-col min-h-screen">
          
          {/* Navbar global */}
          <Navbar />
          
          {/* El contenido principal crece para empujar al footer hacia abajo */}
          <main className="flex-grow">
            <Routes>
              {/* PÁGINA PRINCIPAL */}
              <Route path="/" element={
                <>
                  <Hero />
                  <Planes />
                  <section id="registro" className="py-20 bg-zinc-950">
                    <Formulario />
                  </section>
                  <Chatbot />
                </>
              } />

              {/* PÁGINA DE DETALLES */}
              <Route path="/planes" element={<PlanesDetalle />} />
            </Routes>
          </main>

          {/* Footer global con los créditos de Tecolotl Tech */}
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;